import { isServerSide } from '../request-context'

export const setDebugData = (key: string, data: unknown): void => {
  if (!isServerSide()) {
    window.homeOneDebugData = {
      ...window.homeOneDebugData,
      [key]: data,
    }
  }
}
